<template>
	<div ref="echartLine" style="width:100%;height:100%;">
	</div>
</template>
<script>
	import echarts from 'echarts'
	export default {
		name: 'echartLine',
		props: {
			echartLineData: {
				type: Array,
				default: []
			},
			lineXAxisData: {
				type: Array,
				default: []
			},
			lineDateData: {
				type: Array,
				default: () => []
			}

		},
		data() {
			return {
				series: [],
				legend: []
			}
		},
		mounted() {
			this.getEchart();
			window.addEventListener('resize', this.resize)
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.resize)
		},
		watch: {
			echartLineData: {
				handler: function() {
					this.$nextTick(() => {
						this.getEchart();
					});
				},
				deep: true
			},
			lineXAxisData(n, o) {
				this.$nextTick(() => {
					this.getEchart();
				});
			},
			lineDateData(n, o) {
				this.$nextTick(() => {
					this.getEchart();
				});
			},
		},
		methods: {
			resize(){
				this.myChart.resize()
			},
			getEchart() {
				this.legend = []
				this.series = []
				this.echartLineData.forEach(t => {
					this.legend.push(t.name)
					let series = {
						name: t.name,
						type: 'line',
						data: t.value,
						smooth: true
					}
					this.series.push(series)
				})
				this.myChart = echarts.init(this.$refs.echartLine)
				let option = {
					legend: {
						data: this.legend
					},
					tooltip: {
						trigger: 'axis',
						formatter: (params) => {
							let date = '';
							let value = '';
							let result = ''
							for (var i = 0, l = params.length; i < l; i++) {
								if (this.lineDateData.length) {
									this.lineDateData.forEach((tt, ii) => {
										if (params[i].dataIndex == ii) {
											date = params[i].axisValue + '(' + tt + ')'
											value += '<br/>' + params[i].seriesName + ' : ' + params[i]
												.data;
										}
									})
								} else {
									date = params[i].axisValue
									value += '<br/>' + params[i].seriesName + ' : ' + params[i].data;
								}

							};
							result = date + value
							return result;
						}
					},
					color: ['#60acfc', '#5bc49f', '#feb64d', '#ff7c7c', '#32d3eb', '#9287e7', '#FFEE58', '#f44336',
						'#E91E63', '#CDDC39'
					],
					grid: {
						left: '50px',
						top: '10%',
						right: '3%',
						bottom: '4%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						data: this.lineXAxisData,
						boundaryGap: false,
						// axisTick: {
						//     alignWithLabel: true
						// }
					},
					yAxis: {
						axisLine: {
							show: false
						},
						axisTick: {
							show: false
						},
						type: 'value',
						splitLine: {
							show: true,
							lineStyle: {
								type: 'dashed'
							}
						}
					},
					series: this.series
				};
				this.myChart.setOption(option);
			}
		}
	}
</script>
